// src/lib/presets.ts
import { configRegistry } from '@/lib/configRegistry';

type ListPreset = {
  headers: any[];
  defaultHeaderOrder: string[];
  filters: any[];
  rowActions?: any[];
  defaultQuery?: Record<string, any>;
};

type CardPreset = {
  cardFields: any[];
  defaultCardOrder: string[];
  renderers?: Record<string, any>;
};

export async function loadModuleConfig(moduleName: string) {
  const loader = (configRegistry as any)[moduleName];
  if (!loader) return null;
  return await loader();
}

/** Resuelve el sub-view:
 *  1) si el módulo exporta getView(route) => úsalo
 *  2) si no, prueba con route.meta.view, route.query.view
 *  3) heurística: /:module/<subview>
 */
export function resolveViewName(moduleName: string, route: any, mod: any): string | undefined {
  if (typeof mod?.getView === 'function') {
    return mod.getView(route);
  }
  const byMeta = (route?.meta as any)?.view as string | undefined;
  if (byMeta) return byMeta;

  const byQuery = (route?.query as any)?.view as string | undefined;
  if (byQuery) return byQuery;

  const rx = new RegExp(`^\\/${moduleName.toLowerCase()}\\/([^\\/]+)`, 'i');
  const m = route?.path?.match?.(rx);
  return m?.[1];
}

export function getListPreset(mod: any, view?: string): ListPreset {
  if (typeof mod?.getPreset === 'function') return mod.getPreset(view);
  // fallback legacy
  return {
    headers: mod.HEADERS || [],
    defaultHeaderOrder: mod.DEFAULT_HEADER_ORDER || [],
    filters: mod.FILTERS || [],
    rowActions: mod.ROW_ACTIONS || [],
    defaultQuery: {},
  };
}

export function getCardsPreset(mod: any, view?: string): CardPreset {
  if (typeof mod?.getCardPreset === 'function') return mod.getCardPreset(view);
  // fallback legacy
  return {
    cardFields: mod.CARD_FIELDS || [],
    defaultCardOrder: mod.DEFAULT_CARD_ORDER || [],
    renderers: mod.RENDERERS || {},
  };
}
